import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxPurchaseTypeService } from '@go-modules/services/purchase-type/purchase-type.service';

export const ngxPurchaseTypeServiceModule = angular.module('ngxPurchaseTypeServiceModule', [])
	.factory('ngxPurchaseTypeService', downgradeInjectable(NgxPurchaseTypeService) as any)
	.name;
